import { Observable } from 'rxjs';

import { Training, TrainingRequest, TrainingModel } from 'app/model/machine-learning/training';
import { RestfulApiService } from 'app/services/restful-api.service';
import { ModelWithoutId } from 'app/type';

class TrainingService extends RestfulApiService<Training> {
    public mark(data: ModelWithoutId<TrainingRequest>): Observable<TrainingModel[]> {
        return this.http.post<TrainingModel[]>(this.getUrl(), { [this.getFormName()]: data });
    }

    public clear(mtids: string[]): Observable<{ success: boolean; message?: string }> {
        return this.http.post<{ success: boolean; message?: string }>(`${this.getUrl()}/clear`, {
            clear_training: { mtidArray: mtids },
        });
    }

    protected getFormName(): string {
        return 'training';
    }

    protected getPath(): string {
        return 'ml/training';
    }
}

export const trainingService = new TrainingService();
